import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * Processing transactions list - inherits from all-transactions with Processing status filter.
 * Sorted oldest first so stuck transactions surface at the top.
 */
export const processingTransactionsList: ListBuilderList = {
	id: 'default-transaction-processing',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'Processing',
	type: 'default',
	active: true,
	sortOrder: 5,
	description: 'Processing transactions, oldest first',
	defaultSortId: 'column-transaction-dates-asc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		transactionStatus: {
			defaultValue: [{ id: 'Processing', label: 'Processing' }],
		},
	},
};
